module.exports = __webpack_public_path__ + "img/tents-for-food-banks.7eac5274.jpg";